import Vue from 'vue';
import Vuex from 'vuex';
import Global from './js/global';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
    },
    mutations: {
    }
})
